export default "__VITE_ASSET__86bnH_Pl__"